import Button from "components/common/Buttons";
import { useSelector } from 'react-redux';
import { selectHeader } from "store/slices/GeneralSlice";

const ProductDropdownComponent = () => {
    const header = useSelector(selectHeader)
    return (
        <div className="header-nav__item__dropdown-trial">
            <div className="body1">{header.trials_title}</div>
            <div className="body2">{header.trials_description}</div>
            <Button text={header.trials_button} to={header.trials_button_link} size="S" forPopup={true} />
        </div>
    );
}

export default ProductDropdownComponent;